export const iconFontAwesomeMedicalHealthKitMedical = (
	<i className="fa-solid fa-kit-medical"></i>
);
